module.exports = __webpack_public_path__ + "static/media/recurring.337495dc.svg";